export default __webpack_public_path__ + "static/media/feather_plus-circle-disable.179987e4.svg";